import type { FC } from 'react'

import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { toFaDigits } from '@/lib/format'
import { revealDelay } from '@/lib/motion'
import { ButtonLink } from '@/components/generals/button'
import { SectionHeading } from '@/components/generals/section-heading'

import { SHELL } from '@/constants/site'

const STEPS = [
    {
        title: 'سبد سفارشتان را بچینید',
        text: 'نان، شیرینی و برش‌های کیک را از منو انتخاب کنید. همه‌چیز جز قهوه را می‌شود تا یک هفته جلوتر رزرو کرد.'
    },
    {
        title: 'زمان تحویل حضوری را انتخاب کنید',
        text: 'یک بازه‌ی نیم‌ساعته‌ی دلخواه انتخاب کنید. فقط زمان‌های آزاد نشان داده می‌شوند، از دو ساعت بعد به این طرف.'
    },
    {
        title: 'گرم تحویل بگیرید',
        text: 'اسمتان را پشت پیشخوان بگویید و موقع تحویل پرداخت کنید. سفارشتان بسته‌بندی‌شده منتظرتان است، و اغلب هنوز گرم.'
    }
]

export const HowItWorks: FC = () => (
    <section id='how-ordering-works' aria-labelledby='how-title' className='bg-flour-deep py-20 lg:py-28'>
        <div className={cn(SHELL, 'grid gap-12 lg:grid-cols-12 lg:gap-10')}>
            <div className='lg:col-span-4'>
                <SectionHeading
                    id='how-title'
                    label='پیش‌سفارش'
                    title={<>چطور <span className='italic'>کار می‌کند؟</span></>}
                    intro='پخت دلخواهتان را آنلاین رزرو کنید و از صف شلوغ صبح خلاص شوید. تا سفارش را تحویل نگرفته‌اید، چیزی پرداخت نمی‌کنید.'
                />

                <div data-reveal='up' style={revealDelay(240)}>
                    <ButtonLink href='/order' className='mt-9'>
                        سفارش بدهید
                        <ArrowRight className='size-4 transition-transform duration-500 ease-(--ease-soft) rtl:-scale-x-100 group-hover/button:translate-x-0.5 rtl:group-hover/button:-translate-x-0.5' aria-hidden='true' />
                    </ButtonLink>
                </div>
            </div>

            <ol className='grid border-t border-line-strong/70 sm:grid-cols-3 sm:border-t-0 lg:col-span-8'>
                {STEPS.map((step, index) => (
                    <li
                        key={step.title}
                        className='border-b border-line-strong/70 py-8 sm:border-b-0 sm:border-s sm:px-7 sm:py-1 lg:px-9'
                        data-reveal='up'
                        style={revealDelay(index * 140)}
                    >
                        <span className='font-heading text-[3.25rem] leading-none text-crust-soft italic' aria-hidden='true'>
                            {toFaDigits(String(index + 1).padStart(2, '0'))}
                        </span>

                        <h3 className='mt-8 font-heading text-[1.75rem] leading-snug font-normal sm:mt-14'>
                            <span className='sr-only'>مرحله‌ی {toFaDigits(index + 1)}: </span>
                            {step.title}
                        </h3>

                        <p className='mt-3 text-[0.9375rem] leading-relaxed text-crust-soft'>{step.text}</p>
                    </li>
                ))}
            </ol>
        </div>
    </section>
)
